import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from "react-router-dom";
import MachineList from "./MachineList";
import MachineInfo from "./MachineInfo";
import UserResponse from "./UserResponse";
import CreateMachine from "./CreateMachine";
import Dashboard from "./Dashboard";
import { useSelector } from "react-redux";
import SiteList from "./SiteList";
import CreateSite from "./CreateSite";
import SiteInfo from "./SiteInfo";
import SiteUserSingleResponse from "./SiteUserSingleResponse";
import SiteDashBoard from "./pages/site/SiteDashboard";

const AppRouter = () => {
  const userData = useSelector((state) => state.userSlice);
  const groupId = userData?.user?.group?.uuid;
  let defaultRoute = `/dashboard/${groupId}`;

  return (
    <Routes>
      <Route path="/machine-list/view/:groupId" element={<MachineList />} />
      <Route path="/machine-list/:type" element={<CreateMachine />} />
      <Route path="/machine-info/:uuid" element={<MachineInfo />} />
      <Route path="/user-response/:responseId/:machineId" element={<UserResponse />} />
      <Route path="/dashboard/:groupId" element={<Dashboard />} />
      {/* Site Routes */}
      <Route path="/site/user-response/:responseId" element={<SiteUserSingleResponse />} />
      <Route path="/site-info/:uuid" element={<SiteInfo />} />
      <Route path="/site-list/:type" element={<CreateSite />} />
      <Route path="/site-list/view/:groupId" element={<SiteList />} />
      <Route path="/s/dashboard/:groupId" element={<SiteDashBoard />} />
      <Route path="*" element={<Navigate to={defaultRoute} />} />
    </Routes>
  );
};

export default AppRouter;
